import { memo } from "react";
import { Box, Tooltip } from "@mui/material";
import { formatNumber, formatDecimal, formatLargeNumber } from "../../../../../utils/formatters";
import { getFieldByKey } from "../../../hooks/useTableColumnsConfig";
import getSocialProfileUrl from "../../../../../utils/getSocialProfileUrl/index.ts";

const DefaultCell = ({ row, col }) => {
  const columnObject = getFieldByKey({ columnKey: col })
  return (
    <>
      {col === "bio" ? (
        <Tooltip title={row[col]} arrow placement="top">
          <Box
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {row[col]}
          </Box>
        </Tooltip>
      ) : col === "created_at" ? (
        <Tooltip title={new Date(row[col]).toLocaleString()} arrow>
          <span>
            {new Date(row[col]).toLocaleDateString("en-GB", { year: "numeric", month: "2-digit", day: "2-digit" })}
          </span>
        </Tooltip>
      ) : col === "username" ? (
        <a
          href={ getSocialProfileUrl({ username: row.username, type: "instagram" }) }
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: "underline",
            color: "#1976d2",
            fontWeight: 600,
            cursor: "pointer",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {row[col]}
        </a>
      ) : col === "platform" && row[col]?.toLowerCase() === "instagram" ? (
        <img
          src="/images/Instagram.png"
          alt="Instagram"
          style={{
            width: "28px",
            height: "28px",
            objectFit: "contain",
          }}
        />
      ) : col === "audience_dach" ? (
        row["audience_dach"] !== null && row["audience_dach"] !== undefined ? (
          `${row["audience_dach"]}%`
        ) : (
          "n/a"
        )
      ) : columnObject?.type === "percent" ? (
        formatDecimal(row[col], col)
      ) : ["followers", "reach", "posts"].includes(col) ? (
        formatLargeNumber(row[col])
      ) : (
        formatNumber(row[col])
      )}
    </>
  );
};

export default memo(DefaultCell);
